<ng-container *ifScreenSize="screenType.Mobile">
  <div class="page-header" [ngClass]="{ 'hide-footer': !showFooter }">
    <div class="d-flex align-items-center text-white">
      <div class="banner-name">
        <a (click)="goBack()" class="btn back-btn text-white px-0">
          <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
        </a>
        <h4 class="page-title mb-0" [ngClass]="{ 'text-title-center': !showBalance }">
          {{ pageTitle | translate | uppercase }}
        </h4>
      </div>
      <div *ngIf="showBalance" class="ms-auto d-flex align-items-center font-size-14 widget-details">
        <div class="balance-details d-flex glass-bg gloss-white align-items-center">
          <span class="icons material-symbols-outlined"> loyalty </span>
          <div class="balance">
            <p class="mb-0 font-size-14 fw-bold">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</p>
          </div>
        </div>

        <button *ngIf="showQr" class="btn qrcode-btn glass-bg gloss-white" (click)="goToAccount()">
          <span class="icon material-icons material-mobile-nav text-white">qr_code</span>
        </button>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</ng-container>
